import request from '@/utils/request'

export function getEnum(props) {
  const { name } = props
  return request({
    url: '/common/enum/' + name,
    method: 'get',
  })
}
export function fileUpload(data) {
  return request({
    url: '/pre_upload/api/upload/files',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
}
